import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const updateCity = createAsyncThunk('updateCity', async (data) => {

    try {
        const res = await axios({

            method: 'PUT',
            url: getConfig.API_URL + 'master-city',
            data: {
                "city_id": data?.values?.id,
                "city_name": data?.values?.cityName,
                "state_id": data?.values?.state,
                "country_id": data?.values?.country,
                "description": data?.values?.description,
                "status": data?.values?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})
